import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthContext';
import { config } from '../config';
import { useI18n } from '../i18n';

export function Layout({ children }: { children: ReactNode }) {
  const { t, locale, setLocale } = useI18n();
  const auth = useAuth();

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main">
        跳到主要內容
      </a>

      <header className="app-header">
        <Link className="app-header__brand" to="/">
          <span aria-hidden="true">🎲</span>
          <span>{t('site.title')}</span>
          <small>{t('site.tagline')}</small>
        </Link>

        <nav className="app-header__right" aria-label="site">
          <button
            type="button"
            className="btn btn--ghost btn--sm"
            onClick={() => setLocale(locale === 'zh-TW' ? 'en' : 'zh-TW')}
          >
            {t('lang.switch')}
          </button>

          {/* 登入完全是選配：沒設定 OIDC 就整個不顯示。 */}
          {auth.enabled ? (
            auth.user ? (
              <>
                <Link className="btn btn--sm" to="/me">
                  {t('auth.me')}
                </Link>
                <button type="button" className="btn btn--ghost btn--sm" onClick={auth.logout}>
                  {t('auth.logout')}
                </button>
              </>
            ) : (
              <button type="button" className="btn btn--sm" onClick={() => auth.login('/me')}>
                {t('auth.login')}
              </button>
            )
          ) : null}
        </nav>
      </header>

      <main id="main" className="page">
        {children}
      </main>

      <footer className="app-footer">
        <span>{t('footer.docs')}</span>
        <span className="mono">build {config.buildVersion}</span>
      </footer>
    </div>
  );
}
